// extracted by mini-css-extract-plugin
export default {"breadcrumbsWrapper":"a1fsYy"};